import React from 'react';

import { faUserGraduate } from '@fortawesome/free-solid-svg-icons/faUserGraduate';
import { faUserTie } from '@fortawesome/free-solid-svg-icons/faUserTie';
import { faSchool } from '@fortawesome/free-solid-svg-icons/faSchool';
import { faNewspaper } from '@fortawesome/free-regular-svg-icons/faNewspaper';
import { faColumns } from '@fortawesome/free-solid-svg-icons/faColumns';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons/faPowerOff';
import { faBullhorn } from '@fortawesome/free-solid-svg-icons/faBullhorn';
import { faChartPie } from '@fortawesome/free-solid-svg-icons/faChartPie';
import { faChartLine } from '@fortawesome/free-solid-svg-icons/faChartLine';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons/faTachometerAlt';
import { faTrophy } from '@fortawesome/free-solid-svg-icons/faTrophy';
import { faStarHalfAlt } from '@fortawesome/free-solid-svg-icons/faStarHalfAlt';
import { faChild } from '@fortawesome/free-solid-svg-icons/faChild';
import { faQuestion } from '@fortawesome/free-solid-svg-icons/faQuestion';

import { env } from '~/commons/config';
import NavListItem from './NavListItem.jsx';

const links = [
  ...(env.user.roles.includes('schoolAdmin') ? [
    { to: '/admin/dashboard', icon: faTachometerAlt, label: 'Dashboard' },
  ] : []),

  ...(env.user.roles.includes('admin') ? [
    {
      to: '/admin/users',
      icon: faUser,
      label: 'Users',
      links: [
        { to: '/admin/users/admins', icon: faUserTie, label: 'Admins' },
        {
          to: '/admin/users/students',
          icon: faUserGraduate,
          label: 'Students',
        },
      ],
    },

    { to: '/admin/schools', icon: faSchool, label: 'Schools' },
    { to: '/admin/competitions', icon: faTrophy, label: 'Competitions' },
    { to: '/admin/articles', icon: faNewspaper, label: 'Reading Materials' },
    { to: '/admin/site', icon: faColumns, label: 'Site' },
    { to: '/admin/announcements', icon: faBullhorn, label: 'Announcements' },
  ] : []),

  {
    to: '/admin/reports',
    icon: faChartPie,
    label: 'Reports',
    links: [
      {
        to: '/admin/reports/performance',
        icon: faChartLine,
        label: 'Performance',
      },

      ...(env.user.roles.includes('admin') ? [
        {
          to: '/admin/reports/scores',
          icon: faStarHalfAlt,
          label: 'Scores',
        },
        {
          to: '/admin/reports/participations',
          icon: faChild,
          label: 'Participations',
        },
        {
          to: '/admin/reports/questions',
          icon: faQuestion,
          label: 'Questions',
        },
      ] : []),
    ],
  },

  {
    href: 'logout',
    icon: faPowerOff,
    label: 'Logout',
  },
];

const Nav = () => (
  <nav className="col main-nav bg-white pr-0 py-5">
    <div className="nav flex-column pl-3">
      {links.map((l, i) => (
        <NavListItem key={i} {...l}>
          {l.links && (
            l.links.map((ll, ii) => (
              <NavListItem key={ii} {...ll} />
            ))
          )}
        </NavListItem>
      ))}
    </div>
  </nav>
);

export default Nav;
